import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import { tradePortalService } from "@/app/services/generated/tradeportalService";
import { useVuetify } from "@/plugins/vuetify";
import { tpBranding } from "@tp/tpBranding";
import { tpSessionData } from "@tp/tpSessionData";
import Cookies from "js-cookie";

const cookieName = (storeCode: string) =>
  "tpsession_" + storeCode.toLocaleLowerCase();

const ensureSessionEstablishedForStore = async (storeCode: string) => {
  if (!storeCode) {
    return false;
  }

  if (
    tpSessionData.tenantOrDefault.storeCode.toLocaleLowerCase() ===
    storeCode.toLocaleLowerCase()
  ) {
    // Already established for the given code, so OK.
    return true;
  }

  const fromCookie = Cookies.get(cookieName(storeCode));
  if (fromCookie) {
    const parts = fromCookie.split("-");
    return loadTpSession(
      storeCode,
      parts[0],
      parts[1]?.toLocaleLowerCase() === "true"
    );
  }

  return false;
};

const storeTpSessionCookie = (
  storeCode: string,
  sessionToken: string,
  isMorphedUser: boolean
) => {
  Cookies.set(cookieName(storeCode), sessionToken + "-" + isMorphedUser);
};

const loadTpSession = async (
  storeCode: string,
  sessionToken: string,
  isMorphedUser: boolean
) => {
  const { $vuetify } = useVuetify();

  try {
    const tenant = await tradePortalService.getTpTenant({ sessionToken });
    tpSessionData.setStore(tenant);
    tpSessionData.setSession(sessionToken);
    tpSessionData.setIsMorphedUser(isMorphedUser);
    tenantService.configureForTpTenant(tenant);

    tpBranding.setTenantBranding(tenant, $vuetify);

    storeTpSessionCookie(storeCode, sessionToken, isMorphedUser);
    return true;
  } catch {
    clearTpSession(storeCode);
    return false;
  }
};

const clearTpSession = (storeCode: string) => {
  tpSessionData.setSession("");
  Cookies.remove(cookieName(storeCode));
};

export {
  ensureSessionEstablishedForStore,
  loadTpSession,
  storeTpSessionCookie,
  clearTpSession,
};
